import { AddEditBordMember } from "../Data/AddEditBordMember.data";



export const setAllDropDownFieldForBordMember = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "typeofMember": filterDropDownList("BoardMemberTypeName"),    
    };

    const formFields = [...AddEditBordMember.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};